import React from 'react'

export const IconPlusBig = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.204467 11.7484L11.7045 11.7484M23.2045 11.7484L11.7045 11.7484M11.7045 11.7484L11.7045 0.425294M11.7045 11.7484L11.7045 23.4253"
        stroke="#228E82"
        strokeWidth="3"
      />
    </svg>
  )
}
